import { ListItem, Typography } from "@mui/material";
import { memo } from "react";
import { DEFAULT_AREA_FIELD_ITEM_HEIGHT } from "../../../viewer/common/fields/area-fields/AreaFieldsHelper.ts";

const AreaFieldItemDraggable = memo((props: { caption: string | undefined }) => {
  const { caption } = props;

  return (
    <ListItem
      sx={(theme) => ({
        display: "flex",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "2px",
        p: "5px",
        width: "322px",
        height: `${DEFAULT_AREA_FIELD_ITEM_HEIGHT}px`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: "0px 3px 2px -1px rgba(0, 0, 0, 0.1)",
        "&:hover": {
          cursor: "grab",
        },
      })}
    >
      <Typography variant="caption" sx={{ flexGrow: 1, color: (theme) => theme.palette.text.primary }} noWrap>
        {caption}
      </Typography>
    </ListItem>
  );
});

AreaFieldItemDraggable.displayName = "AreaFieldItemDraggable";

export default AreaFieldItemDraggable;
